import type { SaveMetadata } from "../Types";

export function savedTime(timestamp: string): string {
  const minutes = Math.max(
    0,
    Math.floor((Date.now() - Date.parse(timestamp)) / 60000),
  );
  if (minutes < 1) return "just now";
  if (minutes < 60) return `${minutes} minute${minutes === 1 ? "" : "s"} ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hour${hours === 1 ? "" : "s"} ago`;
  return new Date(timestamp).toLocaleDateString();
}
/** Hide the location in names generated by older versions, preserving player-authored names. */
export function saveTitle(save: SaveMetadata): string {
  const legacyName = `${save.scenarioName} — ${save.locationName}`;
  if (save.name === legacyName) return save.scenarioName;
  if (save.name.startsWith(`${legacyName} (`)) {
    const suffix = save.name.slice(legacyName.length);
    if (/^ \((?:[2-9]|[1-9]\d+)\)$/.test(suffix))
      return `${save.scenarioName}${suffix}`;
  }
  return save.name;
}
